export type FeatureFlags = typeof window.__config__;
export type FeatureFlag = keyof FeatureFlags;

const isFeatureFlagEnabled = (flagName: FeatureFlag): boolean => {
  return window.__config__[flagName] === 'true';
};

export default isFeatureFlagEnabled;
